<template>
  <div class="app-layout">
    <div class="topbar"><slot name="topbar" /></div>
    <div class="sidebar"><slot name="sidebar" /></div>
    <div ref="mainContentContainer" class="main-content">
      <slot name="main-content" />
    </div>
    <slot name="modals" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({});
</script>
<style lang="scss">
.app-layout {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template:
    'top-bar top-bar' min-content
    'sidebar main-content' 1fr
    / min-content 1fr;
  overflow: hidden;

  .topbar {
    grid-area: top-bar;
    z-index: 11000;
    width: 100%;
  }

  .sidebar {
    grid-area: sidebar;
    height: 100%;
  }

  .main-content {
    grid-area: main-content;
    padding-top: 0;
    padding-left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
}
@media print {
  .app-layout .main-content {
    height: auto;
    overflow: visible;
  }
}
</style>
